// extracted by mini-css-extract-plugin
module.exports = {"picture":"image_picture__FKXAx","image":"image_image__VjCRd","cover":"image_cover__oGd44","contain":"image_contain__KCXvG"};